export default __webpack_public_path__ + "static/media/nsf-logo.956d1479.png";